import { render, staticRenderFns } from "./DeskMyntUAT.vue?vue&type=template&id=4e116804"
import script from "./DeskMyntUAT.vue?vue&type=script&lang=js"
export * from "./DeskMyntUAT.vue?vue&type=script&lang=js"
import style0 from "./DeskMyntUAT.vue?vue&type=style&index=0&id=4e116804&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports